// Roles Module
import { api } from '../core/api-client.js';
import { showNotification } from '../utils/notifications.js';
import { hasPermission } from '../utils/permissions.js';

export async function loadRoles() {
    if (!hasPermission('view:settings')) {
        console.log('[Roles] No permission to view roles');
        return;
    }

    try {
        const roles = await api.getRoles();
        console.log('[Roles] Loaded:', roles);
        updateRolesUI(roles);
    } catch (error) {
        console.error('[Roles] Failed to load:', error);
        showNotification('Failed to load roles', 'error');
    }
}

function updateRolesUI(roles) {
    try {
        const tbody = document.querySelector('#roles-table tbody');
        if (!tbody) return;

        tbody.innerHTML = roles.map(role => `
            <tr class="border-b border-slate-800 hover:bg-slate-900/50">
                <td class="py-4 px-4">${role.name}</td>
                <td class="py-4 px-4 text-slate-500">${role.description || '-'}</td>
                <td class="py-4 px-4">
                    <span class="px-2 py-1 bg-slate-800 rounded text-xs">${role.permissions?.length || 0} permissions</span>
                </td>
                <td class="py-4 px-4 text-right">
                    ${!role.is_system ? `
                        <button onclick="editRole(${role.id})" class="text-neonCyan hover:text-white mr-2">
                            <i class="fas fa-edit"></i>
                        </button>
                        <button onclick="deleteRole(${role.id})" class="text-red-500 hover:text-red-400">
                            <i class="fas fa-trash"></i>
                        </button>
                    ` : '<span class="text-slate-600">System Role</span>'}
                </td>
            </tr>
        `).join('');
    } catch (error) {
        console.error('[Roles] Error updating UI:', error);
    }
}

export async function deleteRole(id) {
    if (!confirm('Are you sure you want to delete this role?')) return;

    try {
        await api.deleteRole(id);
        showNotification('Role deleted successfully', 'success');
        loadRoles();
        try {
            const { loadSettings } = await import('./settings.js');
            await loadSettings();
        } catch (_) {
            // settings module optional on some pages
        }
    } catch (error) {
        console.error('[Roles] Failed to delete:', error);
        showNotification('Failed to delete role: ' + error.message, 'error');
    }
}

window.deleteRole = deleteRole;
window.loadRoles = loadRoles;
if (typeof window.editRole !== 'function') {
    window.editRole = async function editRoleFallback(id) {
        showNotification('Open the Roles page to edit roles', 'info');
        console.log('[Roles] editRole fallback for id:', id);
    };
}
